import React from 'react';
import VectorUpArrow from '../assets/images/VectorUpArrow.svg';

export default () => {
  return <img src={VectorUpArrow} alt="" />;
};
